import { createContext, Dispatch, SetStateAction } from "react";

export type MobileContextProps = {
  isMobileListVisible: boolean;
  setIsMobileListVisible: Dispatch<SetStateAction<boolean>>;
};

export const MobileContext = createContext<MobileContextProps>({
  isMobileListVisible: false,
  setIsMobileListVisible: () => {
    throw new Error(
      "setIsMobileListVisible must be used within a MobileContext provider"
    );
  },
});
